(function () {
    'use strict';

    angular
        .module('AsyncPanel')
        .factory('PanelContentTabService', PanelContentTabService);
    const urlReplacerRegex = /<([\w.]*)>/g; // can get this from the config in the future.;
    function PanelContentTabService(lodash, GenericModel) {
        const mem = {};

        return {
            init: init,
            sync: sync,
            refreshModel: refreshModel,
            destroy: destroy,
            setActive: setActive,
            refreshTabVisibility: refreshTabVisibility,
        };

        function init(settings) {
            if (lodash.has(settings, 'identifier')) {
                lodash.set(mem, settings.identifier, settings);
            }
        }

        function sync(identifier, state) {
            mem[identifier].state = state;
        }

        function refreshModel(identifier) {
            if (lodash.has(mem, identifier + '.datasource.model')) {
                let asyncUrl = mem[identifier].datasource.model.url;
                const method = lodash.get(mem[identifier].datasource.model, 'method', 'get');

                asyncUrl = decodeURI(asyncUrl).replace(urlReplacerRegex, (match, submatch) => {
                    return lodash.get(model, submatch, '');
                });

                const resource = new GenericModel(asyncUrl);
                return resource[method]().$promise.then(function(res) {
                    mem[identifier].state.stepModel = res.data;
                    return res;
                }, function() {
                    return arguments;
                });
            }
            return false;
        }

        function destroy(identifier) {
            if (lodash.has(mem, identifier)) {
                delete mem[identifier];
            }
        }

        function setActive(identifier, panel_content_id) {
            if (lodash.has(mem, identifier)) {
                mem[identifier].setActiveFromAction(panel_content_id);
            }
        }

        function refreshTabVisibility(identifier) {
            if (lodash.has(mem, identifier)) {
                mem[identifier].refreshTabsVisibility();
            }
        }
    }
})();